export default {
  all: [],
  one: {},
  templates: [],
  guests: [],
  ceos: [],
};
